import React, {FC, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Button, Result} from "antd";
import {PublicShell} from "../Components/ui/PublicShell";

const EmailConfirmationErrorPage: FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    
    const onBackButtonClicked = useCallback(() => {
        navigate("/Login");
    }, [navigate]);

    return (
        <PublicShell>
        <Result
            status="error"
            title={t("error")}
            subTitle={t("EmailConfirmationErrorPage_Text")}
            extra={<Button type="primary" onClick={onBackButtonClicked}>{t("EmailConfirmationErrorPage_BackButton")}</Button>}
        />
        </PublicShell>
    );
}

export default EmailConfirmationErrorPage;